import { z } from 'zod';

export const validator = z.object({
    title: z.string({
        required_error: 'Professional name is required.',
    }),
});

export type FormShape = z.infer<typeof validator>;
